import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds, WireInstructions } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UpdateVetValueFeeWireInstructionsArg {
    engagementId: number;
    wireInstructions: WireInstructions;
}

export const UpdateVetValueFeeWireInstructions = createAsyncThunk(
    'flowOfFunds/updateVetValueFeeWireInstructions',
    async (arg: UpdateVetValueFeeWireInstructionsArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/FlowOfFunds/${arg.engagementId}/VetValueFees/WireInstructions`,
                arg.wireInstructions
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the VetValue wire instructions');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while saving the VetValue wire instructions.',
                'error'
            );
            throw error;
        }
    }
);
